import BrowserNotSupportedIcon from "@mui/icons-material/BrowserNotSupported";
import { Box, Stack } from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";

export const RuleDivider = ({ isLast }: { isLast?: boolean }) => (
  <Stack
    direction="column"
    alignItems="center"
    justifyContent="center"
    sx={{ ml: 1.75, position: "absolute", top: 0, left: 1.75 }}
  >
    <Box sx={() => ({ width: "1px", height: isLast ? "100px" : "24px", bgcolor: "general.divider" })} />
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        borderColor: "general.divider",
        borderWidth: "1px",
        borderStyle: "solid",
      }}
    >
      {isLast ? (
        <BrowserNotSupportedIcon sx={{ color: "general.divider" }} />
      ) : (
        <GridExpandMoreIcon sx={{ color: "general.divider" }} />
      )}
    </Box>
    {!isLast && <Box sx={{ width: "1px", height: "24px", bgcolor: "general.divider" }} />}
  </Stack>
);
